/* tslint:disable */
/* eslint-disable */
/**
 * Wire API (development)
 * The API for the Clientwire messaging service.
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: support@clientwire.net
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ParticipantPatchRequest
 */
export interface ParticipantPatchRequest {
    /**
     * The display name of the participant. The display name can not be empty or null.
     * @type {string}
     * @memberof ParticipantPatchRequest
     */
    displayName?: string | null;
    /**
     * The preferred language of the participant. The preferred language can not be empty or null.
     * @type {string}
     * @memberof ParticipantPatchRequest
     */
    preferredLanguage?: string | null;
    /**
     * The phone number of a participant if he is a CLIENT; otherwise always null.
     * @type {string}
     * @memberof ParticipantPatchRequest
     */
    phoneNumber?: string | null;
    /**
     * The email of a participant if he is a CLIENT; otherwise always null.
     * @type {string}
     * @memberof ParticipantPatchRequest
     */
    email?: string | null;
}

/**
 * Check if a given object implements the ParticipantPatchRequest interface.
 */
export function instanceOfParticipantPatchRequest(value: object): value is ParticipantPatchRequest {
    return true;
}

export function ParticipantPatchRequestFromJSON(json: any): ParticipantPatchRequest {
    return ParticipantPatchRequestFromJSONTyped(json, false);
}

export function ParticipantPatchRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): ParticipantPatchRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'displayName': json['display_name'] == null ? undefined : json['display_name'],
        'preferredLanguage': json['preferred_language'] == null ? undefined : json['preferred_language'],
        'phoneNumber': json['phone_number'] == null ? undefined : json['phone_number'],
        'email': json['email'] == null ? undefined : json['email'],
    };
}

export function ParticipantPatchRequestToJSON(json: any): ParticipantPatchRequest {
    return ParticipantPatchRequestToJSONTyped(json, false);
}

export function ParticipantPatchRequestToJSONTyped(value?: ParticipantPatchRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'display_name': value['displayName'],
        'preferred_language': value['preferredLanguage'],
        'phone_number': value['phoneNumber'],
        'email': value['email'],
    };
}

